import RegistrarCliente from "./RegistrarCliente";

export default RegistrarCliente;
